import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
  Donation,
  DonationActions,
  DonationType
} from '../transaction-store/donation';
import { AppSettings } from '../app.settings';
import { Observable } from 'rxjs';
import { UserModel } from '../user/login.model';
import { GaClient } from '../../init';
import { PaymentInfo, PaymentInfoActions } from '../transaction-store/payment-info';
import { Sdk } from '../core/sdk.service';

@Component({
  selector: 'app-payment-type',
  template: `
    <section
      class="container"
      *ngIf="!(user$ | async).refresh_token || (paymentInfo$ | async).add"
    >
      <div class="row">
        <h2 class="section-title col-md-2 col">Payment Type</h2>
        <div class="col-md-10">
          <div class="d-flex flex-row justify-content-start flex-wrap">
            <div
              class="payment-type"
              *ngFor="let item of enabledTypes; let i = index"
            >
              <label
                class="btn w-100"
                [ngClass]="
                  item.value == selected
                    ? 'btn-primary'
                    : 'btn-outline-secondary'
                "
                for="payment-type-cc-{{ i }}"
                tabindex="0"
                (keypress)="setSelected($event, item)"
                [attr.aria-label]="'payment type: ' + item.value"
              >
                <input
                  type="radio"
                  name="payment-type"
                  [value]="item.value"
                  id="payment-type-cc-{{ i }}"
                  hidden
                  [(ngModel)]="selected"
                  (ngModelChange)="onChange($event)"
                  required
                />

                <div class="align-middle h-100">
                  <span>{{item.text}}</span>
                  <span *ngIf="item.image">
                    <img class="apple-pay" src={{item.image}}/>
                  </span>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>
  `
})
export class PaymentTypeComponent {
  selected = DonationType.Credit;
  @Select() user$: Observable<UserModel>;
  @Select() paymentInfo$: Observable<PaymentInfo>;
  @Select() donation$: Observable<Donation>;
  private iatsGatewayId: any;

  enabledTypes = [];

  constructor(private store: Store, private settings: AppSettings, private sdk: Sdk) {
    try {
      this.iatsGatewayId = (<any>(
        this.settings.getValue('organization')
      )).attributes.config.payment.iats_payment_gateway_id;
    } catch (e) {
      console.error('Unable to inspect payment gateway id', e);
      this.iatsGatewayId = undefined;
    }

    this.donation$.subscribe(donation => {
      this.selected = donation.type;
      this.enabledTypes = donation.enabledTypes;
    });
  }

  setSelected($event, item) {
    $event.stopPropagation();
    $event.preventDefault();
    if ($event.keyCode === 13 || $event.keyCode === 32) {
      return this.onChange(item.value);
    }
  }

  onChange($event: DonationType) {
    this.store.dispatch(new DonationActions.SetDonationType($event));
    // reset the token if we are switching between donation types, don't want to keep a CC
    // token (if they filled it out for some reason) then decide to go ECheck
    this.store.dispatch(new PaymentInfoActions.SetToken(''));
    this.store.dispatch(new PaymentInfoActions.SetTokenValidation(''));

    // iats hax: postMessage upwards so idonatelib can swap embeds
    if ($event === DonationType.Check && this.iatsGatewayId) {
      window.parent.postMessage(
        JSON.stringify({
          embed_id: this.settings.getValue('id'),
          action: 'setGateway',
          params: {
            gatewayType: 'iats'
          }
        }),
        '*'
      );
    }

    GaClient.trackButtonClick(`Type-${$event}`);
  }
}
